import { useAppSelector } from "../../redux/store";

const DisabledTenantDialog = (): JSX.Element | null => {
  const { tenantDisabled } = useAppSelector((state) => state.app_info);

  if (!tenantDisabled) {
    return null;
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-gray-100'>
      <div className='text-center p-8 bg-white rounded-lg shadow-md max-w-md'>
        <div className='text-red-500 mb-4'>
          <svg className='mx-auto h-16 w-16' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636'
            />
          </svg>
        </div>
        <h1 className='text-2xl font-bold text-gray-800 mb-4'>Tenant Disabled</h1>
        <p className='text-gray-600'>Your tenant has been disabled by your administrator.</p>
      </div>
    </div>
  );
};

export default DisabledTenantDialog;
